<template>
    <div class="apply">
        <!-- banner -->
        <div class="banner">
            <div class="banner_text">
                <p>申请加入</p>
                <p>Apply for membership</p>
            </div>
            <img src="./../../assets/images/home/news_banner.png" alt="">
        </div>
        <!-- 流程 -->
        <div class="flow" v-if="!registerFlag">
            <div class="loc_title">
                <h2 class="one_title">申请对接流程</h2>
                <h4 class="two_title">Application docking process</h4>
            </div>
            <img src="./../../assets/images/home/liuc_img.png" alt="">
            <div class="btn_wrap">
                <el-button @click="registerFlag=true">立即注册</el-button>
            </div>
        </div>
        <!-- 注册 -->
        <div class="register" v-if="registerFlag">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px" class="myform">
                <el-form-item label="用户名" prop="username">
                    <el-input v-model="ruleForm.username" placeholder="请输入用户名" @blur="checkUsername"></el-input>
                    <i v-show="usernameFlag==1" class="el-icon-circle-check site success"></i>
                    <i v-show="usernameFlag==2" class="el-icon-circle-close site error"></i>
                </el-form-item>
                <el-form-item label="密码" prop="password">
                    <el-input type="password" v-model="ruleForm.password" placeholder="请输入密码"></el-input>
                </el-form-item>
                <el-form-item label="重复密码" prop="repassword">
                    <el-input type="password" v-model="ruleForm.repassword" placeholder="请输入重复密码"></el-input>
                </el-form-item>
                <div class="line"></div>
                <el-form-item label="单位名称" prop="unitName">
                    <el-input v-model="ruleForm.unitName" placeholder="请输入单位名称" @blur="checkUnitname"></el-input>
                    <i v-show="unitNameFlag==1" class="el-icon-circle-check site success"></i>
                    <i v-show="unitNameFlag==2" class="el-icon-circle-close site error"></i>
                </el-form-item>
                <el-form-item label="统一社会信用代码" prop="unitCode">
                    <el-input v-model="ruleForm.unitCode" placeholder="请输入统一社会信用代码"></el-input>
                </el-form-item>
                 <el-form-item label="法人" prop="corporation">
                    <el-input v-model="ruleForm.corporation" placeholder="请输入法人"></el-input>
                </el-form-item>
                 <el-form-item label="身份证号码" prop="credentials">
                    <el-input v-model="ruleForm.credentials" placeholder="请输入身份证号码"></el-input>
                </el-form-item>
                <el-form-item label="单位注册地址" prop="unitAddress">
                    <el-input v-model="ruleForm.unitAddress" placeholder="请输入单位注册地址"></el-input>
                </el-form-item>

                 <el-form-item label="单位注册所在地域" required>
                    <el-col :span="8" style="padding-right:10px;">
                        <el-form-item prop="provinceCode">
                            <el-select v-model="ruleForm.provinceCode" placeholder="请选择" @change="selectProvince">
                                <el-option v-for="item in provinceCode" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8" style="padding-right:10px;">
                        <el-form-item prop="cityCode">
                            <el-select v-model="ruleForm.cityCode" placeholder="请选择" @change="selectCity">
                                <el-option v-for="item in cityCode" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8" style="padding-right:10px;">
                        <el-form-item prop="areaCode">
                            <el-select v-model="ruleForm.areaCode" placeholder="请选择">
                                <el-option v-for="item in areaCode" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-form-item>

                <el-form-item label="单位性质" prop="unitType">
                    <el-select v-model="ruleForm.unitType" placeholder="请选择单位性质">
                        <el-option v-for="item in unitTypeData" :key="item.id" :label="item.typeName" :value="item.typeCode"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="单位行业" required>
                    <el-col :span="11">
                        <el-form-item>
                            <el-select v-model="ruleForm.tradeId1" placeholder="请选择" @change="selectTrade">
                                <el-option v-for="item in trade1Data" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="1">&nbsp;</el-col>
                    <el-col :span="11">
                        <el-form-item prop="tradeId">
                            <el-select v-model="ruleForm.tradeId" placeholder="请选择">
                                <el-option v-for="item in trade2Data" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-form-item>
                <el-form-item label="营业执照" required>
                    <el-upload
                        class="myupload"
                        action=""
                        ref="upload" 
                        :limit="1" 
                        :on-change="uploadChange" 
                        :auto-upload="false" 
                        :show-file-list="false" 
                        :file-list="fileList"
                        accept=".jpg,.png,.jpeg,.gif">
                        <img :src="ruleForm.license" alt="">
                        <el-button size="small">选择照片</el-button>
                        <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
                    </el-upload>
                </el-form-item>
                <el-form-item label="电子邮箱" prop="email">
                    <el-input v-model="ruleForm.email" placeholder="请输入电子邮箱"></el-input>
                </el-form-item>
                <el-form-item label="联系人" prop="linkman">
                    <el-input v-model="ruleForm.linkman" placeholder="请输入联系人"></el-input>
                </el-form-item>
                <el-form-item label="联系人手机" prop="linkphone">
                    <el-input v-model="ruleForm.linkphone" placeholder="请输入联系人手机"></el-input>
                </el-form-item>
                <el-form-item class="btn_wrap">
                    <el-button class="close_btn" @click="registerFlag=false">取消</el-button>
                    <el-button class="register_btn" @click="userRegister">注册</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import {userRegister,unitType,address,trade,uploadFile,checkUsername,checkUnitname} from '@/api/home'
export default {
    name:'News',
    data(){
        var validatePhone = (rule, value, callback) => {
            let regExp=/^1\d{10}$/
            var checkRes=regExp.test(value)
            if (!checkRes) {
                callback(new Error('请输入11位手机号码'));
            } else {
                callback();
            }
        };
        var validateCode = (rule, value, callback) => {
            let regExp=/^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$/
            var checkRes=regExp.test(value)
            if (!checkRes) {
                callback(new Error('请输入正确的统一社会信用代码'));
            } else {
                callback();
            }
        };
        var validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.ruleForm.password) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
         var validateCode = (rule, value, callback) => {
            let regExp=/^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$/
            var checkRes=regExp.test(value)
            if (!checkRes) {
                callback(new Error('请输入正确的统一社会信用代码'));
            } else {
                callback();
            }
        };
         var validateIDcard = (rule, value, callback) => {
          var regExp = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
            var IDcardReg=regExp.test(value)
            if (!IDcardReg) {
                callback(new Error('请输入正确的身份证号'));
            } else {
                callback();
            }
        };
        return {
            trade1Data:[],//获取行业列表1
            trade2Data:[],//获取行业列表2
            unitTypeData:[],//单位性质列表
            provinceCode: [],//所属省
            cityCode: [],//所属市
            areaCode: [],//所属区县
            fileList: [],//图片列表
            ruleForm: {
                username: "",//用户名
                password: "",//密码
                repassword: "",//重复密码

                unitName: "",//单位名称
                unitCode: "",//组织机构代码
                corporation:'',// 法人
                credentials:'', // 法人身份证号
                unitAddress: "",//单位注册地址
                provinceCode: "",//所属省
                cityCode: "",//所属市
                areaCode: "",//所属区县
                unitType: "",//单位性质
                tradeId1: "",//单位行业1
                tradeId: "",//单位行业2

                license: "",//营业执照
                email: "",//安全邮箱
                linkman: "",//联系人
                linkphone: "",//联系人手机
            },
            rules: {
                username: [
                    { required: true, message: '用户名不能为空', trigger: 'blur' },
                ],
                password: [
                    { required: true, message: '密码不能为空', trigger: 'blur' }
                ],
                repassword: [
                    { validator: validatePass, trigger: 'blur' }
                ],
                unitName: [
                    { required: true, message: '单位名称不能为空', trigger: 'blur' }
                ],
                unitCode: [
                    { required: true, message: '统一社会信用代码不能为空', trigger: 'blur' },
                    { validator: validateCode, trigger: 'blur' }
                ],
                 corporation: [
                    { required: true, message: '法人不能为空', trigger: 'blur' },
                    // { validator: validateCode, trigger: 'blur' }
                ],
                 credentials: [
                    { required: true, message: '身份证号码不能为空', trigger: 'blur' },
                    { validator: validateIDcard, trigger: 'blur' }
                ],
                unitAddress: [
                    { required: true, message: '单位注册地址不能为空', trigger: 'blur' }
                ],
                provinceCode: [
                    { required: true, message: '所属省不能为空', trigger: 'change' }
                ],
                cityCode: [
                    { required: true, message: '所属市不能为空', trigger: 'change' }
                ],
                areaCode: [
                    { required: true, message: '所属区县不能为空', trigger: 'change' }
                ],
                unitType: [
                    { required: true, message: '单位性质不能为空', trigger: 'change' }
                ],
                tradeId: [
                    { required: true, message: '单位行业不能为空', trigger: 'change' }
                ],
                linkman: [
                    { required: true, message: '联系人不能为空', trigger: 'blur' }
                ],
                linkphone: [
                    { required: true, message: '联系人手机不能为空', trigger: 'blur' },
                    { validator: validatePhone, trigger: 'blur' }
                ],
                email: [
                    { type: 'email',required: true, message: '请输入正确的邮箱地址', trigger: 'blur' }
                ],
            },
            registerFlag:false,
            usernameFlag:0,//用户名是否重复
            unitNameFlag:0,//单位名称是否重复
        }
    },
    mounted(){
        this.unitType()
        this.address()
        this.trade()
    },
    methods:{
        trade(){//获取行业列表
            trade({}).then(res=>{
                // console.log('获取行业列表')
                // console.log(JSON.parse(JSON.stringify(res.data)))
                this.trade1Data=res.data||[]
            })
        },
        address(){//获取行政区划列表
            address({}).then(res=>{
                // console.log('获取行政区划列表')
                // console.log(JSON.parse(JSON.stringify(res.data)))
                this.provinceCode=res.data||[]
            })
        },
        unitType(){//获取单位性质列表
            unitType({}).then(res=>{
                // console.log('获取单位性质列表')
                // console.log(JSON.parse(JSON.stringify(res.data)))
                this.unitTypeData=res.data||[]
            })
        },
        userRegister() {//注册
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    if (!this.ruleForm.license) {
                        this.$message({
                            message: '请先上传营业执照',
                            type: 'error',
                            duration: 2000
                        });
                        return false
                    }
                    if (this.usernameFlag!=1) {
                        this.$message({
                            message: '用户名重复或不符合规符',
                            type: 'error',
                            duration: 2000
                        });
                        return false
                    }
                    if (this.unitNameFlag!=1) {
                        this.$message({
                            message: '单位名称重复或不符合规符',
                            type: 'error',
                            duration: 2000
                        });
                        return false
                    }
                    const loading = this.$loading({
                        lock: true,
                        text: '拼命加载中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    userRegister(this.ruleForm).then(res=>{
                        this.$message({
                            message: res.errmsg,
                            type: 'success',
                            duration: 2000,
                            onClose:()=>{
                                loading.close()
                                this.$router.push({
                                    path:'/login'
                                })
                            }
                        });
                    }).catch(()=>{
                        loading.close()
                    })
                } else {
                    return false;
                }
            });
        },
        selectProvince(val){//选择省
            for (let i = 0; i < this.provinceCode.length; i++) {
                if (val==this.provinceCode[i].id) {
                    this.cityCode=this.provinceCode[i].children
                    break
                }
            }
            this.ruleForm.cityCode=''
            this.ruleForm.areaCode=''
            this.areaCode=[]
        },
        selectCity(val){//选择市
            for (let i = 0; i < this.cityCode.length; i++) {
                if (val==this.cityCode[i].id) {
                    this.areaCode=this.cityCode[i].children
                    break
                }
            }
            this.ruleForm.areaCode=''
        },
        selectTrade(val){//选择行业
            for (let i = 0; i < this.trade1Data.length; i++) {
                if (val==this.trade1Data[i].id) {
                    this.trade2Data=this.trade1Data[i].children
                    break
                }
            }
            this.ruleForm.tradeId=''
        },
        uploadChange(file) {//根据资源上传指定目录
            // console.log('选择文件');
            // console.log(file);
            let formData = new FormData();
            formData.append("file", file.raw);
            uploadFile(formData).then((res)=>{
                // console.log('根据资源上传指定目录返回');
                // console.log(res);
                this.ruleForm.license=res.data.url
            }).catch((err)=>{
                this.$message({
                    message: err.errmsg,
                    type: 'error',
                    duration: '2000',
                })
            })
            this.fileList=[]
        },
        checkUsername(){//验证用户名是否重复
            // console.log('验证用户名是否重复')
            console.log(this.ruleForm.username,"[][]")
            if (this.ruleForm.username) {
                checkUsername({
                    username:this.ruleForm.username
                }).then(res=>{
                    // console.log('成功了')
                    // console.log(JSON.parse(JSON.stringify(res)))
                    this.usernameFlag=1
                }).catch(err=>{
                    // console.log('报错了')
                    // console.log(err)
                    this.usernameFlag=2
                })
            }else{
                this.usernameFlag=0
            }
        },
        checkUnitname(){//验证单位名称是否重复
            if (this.ruleForm.unitName) {
                checkUnitname({
                    unitName:this.ruleForm.unitName
                }).then(res=>{
                    // console.log('成功了')
                    // console.log(JSON.parse(JSON.stringify(res)))
                    this.unitNameFlag=1
                }).catch(err=>{
                    this.unitNameFlag=2
                })
            }else{
                this.unitNameFlag=0
            }
        },
    }
}
</script>

<style lang='scss' scoped>
    .apply{
        width: 100%;
        height: 100%;
        overflow: hidden auto;
        padding-bottom: 84px;
        box-sizing: border-box;
        .banner{
            width: 100%;
            position: relative;
            font-size: 0;
            .banner_text{
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%,-50%);
                width: 1200px;
                // border: 1px solid #0f0;
                p:nth-child(1){
                    font-size: 30px;
                    color: #333;
                }
                p:nth-child(2){
                    font-size: 24px;
                    color: #C9ECE1;
                    margin-top: 15px;
                    // width: 640px;
                    color: #333;
                    line-height: 41px;
                }
            }
            img{
                width: 100%;
                max-height: 400px;
            }
        }
        .flow{
            width: 1200px;
            // border: 1px solid #f00;
            margin: 60px auto;
            // box-sizing: border-box;
            font-size: 0;
            text-align: center;
            .loc_title{
                text-align: center;
                .one_title{
                    font-size: 24px;
                    color: #333;
                }
                .two_title{
                    font-size: 18px;
                    color: #CCC;
                    font-weight: normal;
                    margin-top: 10px;
                }
            }
            img{
                max-width: 100%;
                margin-top: 25px;
            }
            .btn_wrap{
                text-align: center;
                margin-top: 150px;
                .el-button{
                    background-color: #00AA73;
                    font-size: 18px;
                    color: #fff;
                }
            }
        }
        .register{
            width: 900px;
            // border:1px solid #f00;
            margin: 60px auto;
            .myform{
                width: 550px;
                // border: 1px solid #0f0;
                margin: 0 auto;
                ::v-deep {.el-form-item__label{
                    font-weight: 700;
                }
            }
                .register_btn{
                    background-color: #00AA73;
                    border: 2px solid #00AA73;
                    font-size: 16px;
                    color: #fff;
                    width: 135px;
                    font-weight: 700;
                }
                .close_btn{
                    border: 2px solid #00AA73;
                    width: 135px;
                    font-size: 16px;
                    margin-right: 60px;
                    font-weight: 700;
                    color: #00AA73;
                }
                .btn_wrap{
                    margin-top: 60px;
                    text-align: center;
                    ::v-deep {.el-form-item__content{
                        margin-left: 0 !important;
                    }
                }
                }
                .line{
                    width: 882px;
                    height: 1px;
                    background-color: #E6E6E6;
                    margin: 30px 0 30px -166px;
                }
                .site{
                    position: absolute;
                    font-size: 20px;
                    top: 50%;
                    right: -25px;
                    transform: translateY(-50%);
                }
                .success{
                    color: #67C23A;
                }
                .error{
                    color: #F56C6C;
                }
                .myupload{
                    ::v-deep {.el-upload{
                        display: flex;
                        align-items: center;
                        img{
                            max-width: 500px;
                        }
                    }
                }
                }
            }
        }
    }
</style>